// extracted by mini-css-extract-plugin
module.exports = {"content":"Content-module__content___1WDS1","container":"Content-module__container___InC70","plain":"Content-module__plain___1yiCS","emphasise":"Content-module__emphasise___3jFme"};